import type { TopTab } from '../routes/route';
import type { KnotState } from './Knot';

// R1a — the SINGLE source of truth for the primary nav. The bottom nav
// (phone) and the side rail (tablet/desktop) are two renderings of THIS
// model: the same four tab destinations, the same active/gold rule, and the
// Knot as the central capture action. Neither renderer defines its own tab
// list — they both map over NAV_DESTINATIONS and share isGoldTab/navHref, so
// a destination added or relabelled here shows up in both without a second
// edit.
export interface NavModelProps {
  active: TopTab;
  onNavigate: (tab: TopTab) => void;
  knotState: KnotState;
  onKnotPress: () => void;
}

export interface NavDestination {
  tab: TopTab;
  /** Full label — used by the side rail, where there's room. */
  label: string;
  /** Space-tight variant for the phone bottom bar (e.g. "Audit'ns"). */
  short: string;
}

// Order matches the locked 5-slot shell: Today · Auditions · [Knot] ·
// Projects · Career. The bottom nav splits this list around the centred
// Knot (first two left, last two right); the rail lays it out top-to-bottom
// with the Knot in the same middle position.
export const NAV_DESTINATIONS: NavDestination[] = [
  { tab: 'today', label: 'Today', short: 'Today' },
  { tab: 'auditions', label: 'Auditions', short: "Audit'ns" },
  { tab: 'projects', label: 'Projects', short: 'Projects' },
  { tab: 'career', label: 'Career', short: 'Career' },
];

/** Where the Knot sits when the destination list is split into a
 *  before-Knot and after-Knot half (bottom nav) or interleaved (rail). */
export const KNOT_SLOT_INDEX = 2;

export function navHref(tab: TopTab): string {
  return `#${tab === 'today' ? '/' : `/${tab}`}`;
}

// Career is the one distinct "mode" — it lights GOLD when active; every
// other tab uses the ordinary active colour. Nothing else in the nav ever
// takes gold (the Knot excepted — it's gold by its own nature).
export function isGoldTab(tab: TopTab): boolean {
  return tab === 'career';
}
